import {
  branch,
  compose,
  pure,
  renderComponent,
  renderNothing,
  setDisplayName
} from 'recompose';

import { Apps } from '../../core/Apps';
import Widget from '../../views/WidgetList/Widget';
import AudiencesHome from '../Audiences/audiencesHome';
import RankingHome from '../Audiences/rankingHome';
// import AudiencesRadio from '../Audiences/AudiencesRadio';
import RadioAudience from '../RadioAudience/home';
import DigitalAudience from '../DigitalAudience/home';
import Strategy from '../Strategy/home';
import RRSSAudience from '../RRSSAudience/home';
import Instagram from '../Instagram';
import MDIII from '../MDIII';
import Plata from '../Plata';
import EventPlayer from '../EventPlayer';
import EventPlayer2 from '../EventPlayer2';
import MenuDay from '../Menu/MenuDay';
import PressRelease from '../PressRelease/PressReleaseHome';
import PressResume from '../PressResume/home';
import Twitter from '../Twitter';
import ZeroWaste from '../ZeroWaste';
import CustomWidget from '../CustomWidget';
import WeAreModule from '../WeAreModule';
import Gympass from '../Gympass';
import OracleHCM from '../OracleHCM';
import Hoop from '../Hopp';
import EventEditAtresmedia from '../EventEditAtresmedia';
import AtresmediaIa from '../AtresmediaIa';
import PeriodismoConfiable from '../PeriodismoConfiable';

export default compose(
  setDisplayName('WidgetContainer'),
  branch(
    props => props.type === 'menuofday',
    renderComponent(MenuDay),
    branch(
      props => props.type === 'resumen',
      renderComponent(PressResume),
      branch(
        props => props.type === 'audiences',
        renderComponent(AudiencesHome),
        branch(
          props => props.type === 'pressrelease',
          renderComponent(PressRelease),
          branch(
            props => props.type === 'digitalaudiences',
            renderComponent(DigitalAudience),
            branch(
              props => props.type === 'ranking',
              renderComponent(RankingHome),
              branch(
                props => props.type === 'twitter',
                renderComponent(Twitter),
                branch(
                  props => props.type === 'instagram',
                  renderComponent(Instagram),
                  branch(
                    props => props.type === 'audiencesradio',
                    renderComponent(RadioAudience),
                    branch(
                      props => props.type === 'zerowaste',
                      renderComponent(ZeroWaste),
                      branch(
                        props => props.type === 'customWidget',
                        renderComponent(CustomWidget),
                        branch(
                          props => props.type === 'oraclehcm',
                          renderComponent(OracleHCM),
                          branch(
                            props => props.type === 'wearemodule',
                            renderComponent(WeAreModule),
                            branch(
                              props => props.type === 'gympass',
                              renderComponent(Gympass),
                              branch(
                                props => props.type === 'md3',
                                renderComponent(MDIII),
                                branch(
                                  props => props.type === 'plata',
                                  renderComponent(Plata),
                                  branch(
                                    props => props.type === 'periodismo',
                                    renderComponent(PeriodismoConfiable),
                                    branch(
                                      props => props.type === 'player',
                                      renderComponent(EventPlayer),
                                      branch(
                                        props => props.type === 'player2',
                                        renderComponent(EventPlayer2),
                                        branch(
                                          props =>
                                            props.type === 'editAtresmedia',
                                          renderComponent(EventEditAtresmedia),
                                          branch(
                                            props =>
                                              props.type === 'rrssaudiencia',
                                            renderComponent(RRSSAudience),
                                            branch(
                                              props =>
                                                props.type === 'strategy',
                                              renderComponent(Strategy),
                                              branch(
                                                props =>
                                                  props.type ===
                                                  'atresmedia_ia',
                                                renderComponent(AtresmediaIa),
                                                branch(
                                                  props =>
                                                    props.type === 'hoop',
                                                  renderComponent(Hoop),
                                                  branch(
                                                    props =>
                                                      props.type ===
                                                        'shortcut' ||
                                                      props.type ===
                                                        'shortcutWidget',
                                                    renderComponent(Apps),
                                                    renderNothing
                                                  )
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  ),
  pure
)(Widget);
